import moment from 'moment';
import { Dispatch } from 'redux';
import { EmployeeDTO } from '../../models/dto/EmployeeDTO';
import { EmployeePunchCardDTO } from '../../models/dto/EmployeePunchCardDTO';
import { PeriodDTO } from '../../models/dto/PeriodDTO';
import { api } from '../../services/api';

export const employeesActionsTypes = {
  GET_EMPLOYEES: 'GET_EMPLOYEES',
  GET_EMPLOYEES_SUCCESS: 'GET_EMPLOYEES_SUCCESS',
  GET_EMPLOYEES_FAILURE: 'GET_EMPLOYEES_FAILURE',

  SELECT_EMPLOYEE: 'SELECT_EMPLOYEE',
};

export const getEmployees = (reference: number) => async (
  dispatch: Dispatch,
) => {
  dispatch({ type: employeesActionsTypes.GET_EMPLOYEES });
  try {
    const { data } = await api.get<EmployeeDTO[]>(
      `/gdp/funcionarios/referencia/${reference}?controleRegistroHora=4`,
    );
    dispatch({
      type: employeesActionsTypes.GET_EMPLOYEES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    dispatch({ type: employeesActionsTypes.GET_EMPLOYEES_FAILURE });
  }
};

export const getEmployeePunchCard = async (
  employee: EmployeeDTO,
  period: PeriodDTO,
): Promise<EmployeePunchCardDTO[]> => {
  try {
    const { data } = await api.get<EmployeePunchCardDTO[]>(
      `/gdp/pontos/funcionarios/${employee.numeroCadastro}`,
      {
        params: {
          periodoDe: moment(period.inicioMesApuracao, 'DD/MM/YYYY').format(
            'YYYY-MM-DD',
          ),
          periodoAte: moment(period.fimMesApuracao, 'DD/MM/YYYY').format(
            'YYYY-MM-DD',
          ),
          numCra: employee.numeroCracha,
        },
      },
    );

    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const selectEmployee = (employee: EmployeeDTO | null) => (
  dispatch: Dispatch,
) => {
  dispatch({
    type: employeesActionsTypes.SELECT_EMPLOYEE,
    payload: employee,
  });
};
